<template>
  <header
    class="header"
    :class="{ 'is-open': isOpen }"
  >
    <div class="header-inner">
      <div class="flex items-center z-20">
        <kf-button
          class="btn-nav"
          @click="toggleMenu"
        >
          <span
            aria-hidden="true"
            class="btn-nav__line btn-nav__line--first"
          /><span
            aria-hidden="true"
            class="btn-nav__line btn-nav__line--second"
          /><span
            aria-hidden="true"
            class="btn-nav__line btn-nav__line--third"
          /><span class="sr-only">Open menu</span>
        </kf-button>
        <div class="header-logo">
          <a
            v-if="!disableLogoLink"
            :href="`/${locale}`"
            aria-label="Back to the homepage"
          >
            <kf-logo :logo="logo" />
          </a>
          <kf-logo
            v-if="disableLogoLink"
            :logo="logo"
          />
        </div>
      </div>
      <div
        v-if="secondaryLogoUrl"
        class="header__secondary-logo-container"
      >
        <img
          :src="secondaryLogoUrl"
          alt=""
          class="header__secondary-logo"
        >
      </div>
      <the-navigation
        :nav-items="navItems"
        :class="[isOpen ? 'is-open' : 'is-closed']"
        :search-action="searchAction"
        :search-placeholder="searchPlaceholder"
      />
      <div class="header-inner-right">
        <navigation-meta
          :current-locale="locale"
          :languages="languages"
          :search-action="searchAction"
          :search-placeholder="searchPlaceholder"
        />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TheHeader',
  components: {
    KfLogo: () => import(/* webpackChunkName: "main" */ '@/components/base/logo/Logo.vue'),
    TheNavigation: () => import(/* webpackChunkName: "main" */ '@/components/TheNavigation.vue'),
    NavigationMeta: () => import(/* webpackChunkName: "main" */ '@/components/NavigationMeta.vue'),
    KfButton: () => import(/* webpackChunkName: "main" */ '@/components/base/button/Button.vue'),
  },
  props: {
    navItems: {
      type: Array,
      default: null,
    },
    logo: {
      type: String,
      default: '',
    },
    disableLogoLink: {
      type: Boolean,
      default: false,
    },
    secondaryLogoUrl: {
      type: String,
      default: '',
    },
    locale: {
      type: String,
      default: 'nl',
    },
    languages: {
      type: Array,
      default: null,
    },
    searchAction: {
      type: String,
      default: null,
    },
    searchPlaceholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    changeLanguage(locale) {
      // set formulate
      this.$formulate.setLocale(locale);
    },
    toggleMenu: function() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="postcss" scoped>
.header {
  @apply w-full flex bg-white relative z-30 shadow;
  min-height: 55px;

  @screen md {
    @apply px-0 pt-4;
    height: 120px;
  }

  &__secondary-logo-container {
    @apply hidden h-2/4 z-20;

    @screen sm {
      @apply flex flex-col flex-nowrap justify-center items-start flex-grow;
    }

    @screen lg {
      @apply flex-grow-0 mr-10;
      transform: translateY(10px);
    }

    img {
      max-width: 8rem;
      max-height: 100%;
    }
  }

  &.is-open {
    @screen md {
      @apply bg-transparent;
    }

    .btn-nav {
      &__line--first {
        top: 50%;
        transform: rotate(-45deg);
      }

      &__line--second {
        left: 10px;
        opacity: 0;
      }

      &__line--third {
        top: 50%;
        transform: rotate(45deg);
        width: 18px;
      }
    }
  }

  &-inner {
    @apply relative w-full mx-auto flex lg:container px-5 md:px-4 items-center justify-between z-10;

    &-right {
      @screen md {
        @apply flex-col items-end justify-center w-auto relative;
      }
    }
  }
}

.btn-nav {
  @apply block relative mr-4;
  height: 20px;
  width: 20px;

  @screen lg {
    @apply hidden;
  }

  &__line {
    display: block;
    width: 18px;
    height: 2px;
    border-radius: 2px;
    background-color: theme('colors.primary.bravo');
    position: absolute;
    left: 0;
    transition: all 300ms;
  }

  &__line--first {
    top: 3px;
  }

  &__line--second {
    top: 9px;
  }

  &__line--third {
    top: 15px;
    width: 13px;
  }
}
</style>
